<template>
  <BaseModule
    v-bind="$props"
    class="module-footer remove-padding"
    data-module="new-footer"
    :style="{
      '--bg-color': backgroundColorFooter,
    }"
  >
    <footer class="footer has-text-centered">
      <div
        class="container footer__main"
        :class="{
          'align-left': columnCount === 1,
        }"
      >
        <div
          v-if="hasContacts"
          class="column contact-links"
        >
          <h3
            class="footer-title"
            :style="{ borderColor: textColor }"
          >
            {{ firstTitleColumn }}
          </h3>
          <ul class="contact-links__list">
            <li
              v-for="(contact, index) in contacts"
              :key="index"
              class="contact-links__list__item"
            >
              <EditorLink
                v-if="shouldShowContact(contact)"
                :model="getContactHref(contact)"
                class="contact-links__list__item__link"
                :class="{ 'not-active': !hasText(getContactHref(contact)) }"
              >
                <span
                  v-if="contact.contactType === 'telefone'"
                  class="contact-links__list__icon"
                >
                  <IconSmartphone />
                </span>
                <span
                  v-else-if="contact.contactType === 'whatsapp'"
                  class="contact-links__list__icon"
                >
                  <IconWhatsApp />
                </span>
                <span
                  v-else-if="contact.contactType === 'email'"
                  class="contact-links__list__icon"
                >
                  <IconMail />
                </span>
                <span
                  v-else-if="contact.contactType === 'endereco'"
                  class="contact-links__list__icon"
                >
                  <IconPin />
                </span>
                <span
                  v-else-if="contact.contactType === 'razao'"
                  class="contact-links__list__icon"
                >
                  <IconBuilding />
                </span>
                <span class="contact-label">
                  {{ contact.label }}
                </span>
                {{ getContactDisplayText(contact) }}
              </EditorLink>
            </li>
          </ul>
        </div>

        <div
          v-if="hasSocialLinks || showFlags"
          class="column social-e-flag"
        >
          <div
            v-if="hasContacts"
            class="before"
            :style="{ backgroundColor: textColor }"
          ></div>
          <div
            v-if="hasMenuLinks"
            class="after"
            :style="{ backgroundColor: textColor }"
          ></div>
          <div
            v-if="showFlags"
            class="flags"
          >
            <h3
              class="footer-title"
              :style="{ borderColor: textColor }"
            >
              {{ paymentTitleColumn }}
            </h3>
            <ul class="flags__list">
              <li
                v-for="(flag, index) in filteredFlags"
                :key="index"
                class="flags__list__item"
              >
                <LImage
                  class="flags__list__item__flag"
                  :src="`/payment/${flag.imgName}.png`"
                  :alt="flag.name"
                  loader-size="24"
                />
              </li>
            </ul>
          </div>
          <div
            v-if="hasSocialLinks"
            class="socials"
          >
            <h3
              class="footer-title"
              :style="{ borderColor: textColor }"
            >
              {{ secondTitleColumn }}
            </h3>
            <ul class="socials__list">
              <li
                v-for="(socialObj, index) in socialLinks"
                :key="index"
                class="socials__list__item"
              >
                <EditorLink
                  v-if="showIcon(socialObj)"
                  :model="socialObj.linkURL"
                  class="socials__list__item__link"
                  :title="socialObj.title"
                >
                  <component
                    :is="socialObj.socialType"
                    :color="textColor"
                    width="30"
                    height="30"
                  />
                </EditorLink>
              </li>
            </ul>
          </div>
        </div>

        <div
          v-if="hasMenuLinks"
          class="column links"
        >
          <div
            v-if="hasContacts && !hasSocialLinks && !showFlags"
            class="before"
            :style="{ backgroundColor: textColor }"
          ></div>
          <h3
            class="footer-title"
            :style="{ borderColor: textColor }"
          >
            {{ thirdTitleColumn }}
          </h3>
          <ul class="links__list">
            <li
              v-for="(link, index) in menuLinks"
              :key="index"
              class="links__list__item"
            >
              <EditorLink
                v-if="
                  (hasText(link.linkUrl) ||
                    (link.menuLinks && link.menuLinks.length)) &&
                  hasText(link.linkText)
                "
                :model="link.linkUrl"
                class="links__list__item__link"
              >
                {{ link.linkText }}
              </EditorLink>
              <ul
                v-if="link.menuLinks && link.menuLinks.length"
                class="links__list"
              >
                <li
                  v-for="(subLink, subIndex) in link.menuLinks"
                  :key="subIndex"
                  class="links__list__item"
                >
                  <EditorLink
                    v-if="hasText(subLink.linkUrl) && hasText(subLink.linkText)"
                    :model="subLink.linkUrl"
                    class="links__list__item__link"
                  >
                    {{ subLink.linkText }}
                  </EditorLink>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>

      <div
        class="footer__bottom"
        :style="{ backgroundColor: backgroundColorFooterBottom }"
      >
        <div class="container">
          <div class="column footer__bottom__name">
            {{ hotelName }}
          </div>
          <div class="column footer__bottom__links">
            <div
              v-if="showTermos"
              class="footer__bottom__links__item"
              @click="showModal('termos')"
            >
              <span v-if="isModal(termosType)">
                {{ termosTitle }}
              </span>
              <EditorLink
                v-else
                :model="getTermosHref"
              >
                {{ termosTitle }}
              </EditorLink>
            </div>

            <div
              v-if="showPoliticas"
              class="footer__bottom__links__item"
              @click="showModal('politicas')"
            >
              <span v-if="isModal(politicasType)">
                {{ politicasTitle }}
              </span>
              <EditorLink
                v-else
                :model="getPoliticasHref"
              >
                {{ politicasTitle }}
              </EditorLink>
            </div>
          </div>
          <div class="column footer__bottom__letsbook">
            Powered by
            <span class="logo">
              <a
                href="https://letsbook.com.br"
                target="_blank"
              >
                <Logo
                  :width="null"
                  :height="null"
                  :color="textColor"
                />
              </a>
            </span>
          </div>
        </div>
      </div>
    </footer>

    <template slot="modal">
      <Modal
        v-if="isModalVisible"
        :title="modalTitle"
        :text="modalText"
        @close="closeModal"
      />
    </template>
  </BaseModule>
</template>

<script>
import { mapGetters } from 'vuex';

import flagsPayment from '@/helpers/flagsPayment.json';
import IconSmartphone from '@/components/icons/IconSmartphone.vue';
import IconWhatsApp from '@/components/icons/IconWhatsApp.vue';
import IconWhatsApp2 from '@/components/icons/IconWhatsApp2.vue';
import IconMail from '@/components/icons/IconMail.vue';
import IconPin from '@/components/icons/IconPin.vue';
import IconBuilding from '@/components/icons/IconBuilding.vue';
import IconFacebook from '@/components/icons/IconFacebook.vue';
import IconInstagram from '@/components/icons/IconInstagram.vue';
import IconYoutube from '@/components/icons/IconYoutube.vue';
import IconLinkedin from '@/components/icons/IconLinkedin.vue';
import IconTripAdvisor from '@/components/icons/IconTripAdvisor.vue';
import IconTwitter from '@/components/icons/IconTwitter.vue';
import IconSpotify from '@/components/icons/IconSpotify.vue';
import IconTikTok from '@/components/icons/IconTikTok.vue';
import IconLogo from '@/components/icons/IconLogo.vue';
import getApiHotels from '@/mixins/getApiHotels';
import Modal from './Modal.vue';
import EditorLink from './EditorLink.vue';
import BaseModule from './generic/BaseModule.vue';

const tinycolor = require('tinycolor2');

export default {
  name: 'NewFooter',
  components: {
    Modal,
    BaseModule,
    EditorLink,
    IconSmartphone,
    IconWhatsApp,
    IconMail,
    IconPin,
    IconBuilding,
    facebookLink: IconFacebook,
    instagramLink: IconInstagram,
    youTubeLink: IconYoutube,
    linkedinLink: IconLinkedin,
    tripAdvisorLink: IconTripAdvisor,
    twitterLink: IconTwitter,
    spotifyLink: IconSpotify,
    tiktokLink: IconTikTok,
    whatsApp: IconWhatsApp2,
    Logo: IconLogo,
  },
  mixins: [getApiHotels],
  inheritAttrs: false,
  props: {
    ...BaseModule.props,
    hotelName: {
      type: String,
      default: '',
    },
    backgroundColorFooter: {
      type: String,
      default: '',
    },
    flagsOption: {
      type: String,
      default: 'without',
    },
    hotelId: {
      type: Number,
      default: 1,
    },
    textColor: {
      type: String,
      default: '#ffffff', // overrides default
    },
    contacts: {
      type: Array,
      default() {
        return [];
      },
    },
    socialLinks: {
      type: Array,
      default() {
        return [];
      },
    },
    menuLinks: {
      type: Array,
      default() {
        return [];
      },
    },
    termosType: {
      type: String,
      default: '',
    },
    termosTitle: {
      type: String,
      default: '',
    },
    termosText: {
      type: String,
      default: '',
    },
    termosMaterial: {
      type: String,
      default: '',
    },
    termosLink: {
      type: Object,
      default: () => ({
        type: 'externalLink',
        value: '',
        openInNewTab: true,
      }),
    },
    politicasType: {
      type: String,
      default: '',
    },
    politicasTitle: {
      type: String,
      default: '',
    },
    politicasText: {
      type: String,
      default: '',
    },
    politicasMaterial: {
      type: String,
      default: '',
    },
    politicasLink: {
      type: Object,
      default: () => ({
        type: 'externalLink',
        value: '',
        openInNewTab: true,
      }),
    },
    firstTitleColumn: {
      type: String,
      default: 'Contato',
    },
    secondTitleColumn: {
      type: String,
      default: 'Redes Sociais',
    },
    thirdTitleColumn: {
      type: String,
      default: 'Informações',
    },
    paymentTitleColumn: {
      type: String,
      default: 'Formas de pagamento',
    },
    enableLinkURL: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isModalVisible: false,
      modalTitle: '',
      modalText: '',
      flags: [],
    };
  },
  computed: {
    columnCount() {
      // false === 0 e true === 1
      const count =
        this.hasContacts +
        (this.hasSocialLinks || this.showFlags) +
        this.hasMenuLinks;

      return count;
    },
    hasMenuLinks() {
      return this.menuLinks?.length > 0;
    },
    hasSocialLinks() {
      return this.socialLinks.length > 0;
    },
    hasContacts() {
      return this.contacts.length > 0;
    },
    backgroundColorFooterBottom() {
      return this.darken(this.backgroundColorFooter, 8);
    },
    showFlags() {
      return (
        (this.flagsOption === 'chain' || this.flagsOption === 'hotel') &&
        this.flags.length > 0
      );
    },
    getTermosHref() {
      return this.termosType === 'file' ? this.termosMaterial : this.termosLink;
    },
    getPoliticasHref() {
      return this.politicasType === 'file'
        ? this.politicasMaterial
        : this.politicasLink;
    },
    showTermos() {
      return this.termosType !== '';
    },
    showPoliticas() {
      return this.politicasType !== '';
    },
    filteredFlags() {
      return this.flags.reduce((acc, flag) => {
        const mappedFlag = flagsPayment.find(
          (item) => item.name.toLowerCase() === flag.NomeCartao.toLowerCase(),
        );

        if (mappedFlag) {
          acc.push(mappedFlag);
        }

        return acc;
      }, []);
    },
    ...mapGetters(['settings', 'hasLetsbookIntegration']),
  },
  watch: {
    flagsOption(option) {
      this.flags = [];

      if (option === 'chain') {
        this.requestFlags();
      } else if (option === 'hotel' && typeof this.hotelId === 'number') {
        this.requestFlags(true);
      }
    },
    hotelId(val) {
      if (typeof val === 'number' && this.flagsOption === 'hotel') {
        this.requestFlags(true);
      }
    },
  },
  mounted() {
    if (this.hasLetsbookIntegration) {
      this.getApiHotels();

      if (this.flagsOption === 'chain') {
        this.requestFlags();
      } else if (
        this.flagsOption === 'hotel' &&
        typeof this.hotelId === 'number'
      ) {
        this.requestFlags(true);
      }
    }
  },
  methods: {
    darken(color, amt) {
      return tinycolor(color).darken(amt).toString();
    },
    onlyNumbers(text) {
      return text.match(/\d+/g).join('');
    },
    shouldShowContact(contact) {
      let shouldShow = false;
      switch (contact.contactType) {
        case 'whatsapp':
          shouldShow = /\S/.test(contact.label) && /\S/.test(contact.number);
          break;
        case 'telefone':
          shouldShow = /\S/.test(contact.label) && /\S/.test(contact.number);
          break;
        case 'email':
          shouldShow = /\S/.test(contact.label) && /\S/.test(contact.email);
          break;
        case 'endereco':
          shouldShow = /\S/.test(contact.label);
          break;
        case 'razao':
          shouldShow = /\S/.test(contact.label);
          break;
        default:
          shouldShow = false;
      }
      return shouldShow;
    },
    getContactHref(contact) {
      let href = '';
      switch (contact.contactType) {
        case 'whatsapp':
          href = `https://wa.me/${this.onlyNumbers(
            contact.ddi + contact.ddd + contact.number,
          )}`;
          break;
        case 'telefone':
          href = `tel:${this.onlyNumbers(
            contact.ddi + contact.ddd + contact.number,
          )}`;
          break;
        case 'email':
          href = `mailto:${contact.email}`;
          break;
        case 'endereco':
          href =
            contact.enableLinkURL && contact.linkURL ? contact.linkURL : '';
          break;
        case 'razao':
          href =
            contact.enableLinkURL && contact.linkURL ? contact.linkURL : '';
          break;
        default:
          href = '';
      }
      return href;
    },
    hasText(link) {
      return /\S/.test(link);
    },
    showIcon(socialObj) {
      return socialObj.socialType && socialObj.linkURL?.value;
    },
    getContactDisplayText(contact) {
      let label = '';
      let { ddd } = contact;
      switch (contact.contactType) {
        case 'whatsapp':
          if (typeof contact.ddd === 'undefined') {
            ddd = '';
          }
          label = `${contact.ddi} ${ddd} ${contact.number}`;
          break;
        case 'telefone':
          if (typeof contact.ddd === 'undefined') {
            ddd = '';
          }
          label = `${contact.ddi} ${ddd} ${contact.number}`;
          break;
        case 'email':
          label = contact.email;
          break;
        default:
          label = '';
      }
      return label;
    },
    async requestFlags(byHotel) {
      this.flags = [];
      const urlFlags = `${this.settings.letsbookApiId}/${
        byHotel
          ? `formasPagamentoHotel/${this.hotelId}`
          : `formasPagamentoLanding/${this.settings.letsbookLandingPageId}`
      }`;

      if (!this.apiData[urlFlags]) {
        try {
          await this.$store.dispatch('loadApiData', urlFlags);
        } catch (error) {
          console.log(error);
        }
      }

      this.flags = this.apiData[urlFlags];
    },
    showModal(origin) {
      if (origin === 'termos') {
        this.modalTitle = this.termosTitle;
        this.modalText = this.termosText;
        this.isModalVisible = this.termosType === 'modal';
      } else if (origin === 'politicas') {
        this.modalTitle = this.politicasTitle;
        this.modalText = this.politicasText;
        this.isModalVisible = this.politicasType === 'modal';
      }
    },
    closeModal() {
      this.isModalVisible = false;
    },
    isModal(origin) {
      return origin === 'modal';
    },
  },
  metadata: {
    extends: BaseModule.metadata,
    tabs: [
      {
        name: 'content',
        groups: [
          {
            name: 'contacts',
            label: 'Contatos',
            fields: [
              {
                name: 'firstTitleColumn',
                type: 'ShortText',
                label: 'Título',
              },
              {
                type: 'List',
                name: 'contacts',
                itemLabel: 'Contato {index}',
                addItemLabel: 'Adicionar contato',
                fields: [
                  {
                    name: 'contactType',
                    type: 'VueSelect',
                    label: 'Tipo de contato',
                    default: '',
                    options: [
                      {
                        label: 'Whatsapp',
                        value: 'whatsapp',
                      },
                      {
                        label: 'Telefone',
                        value: 'telefone',
                      },
                      {
                        label: 'E-mail',
                        value: 'email',
                      },
                      {
                        label: 'Endereço',
                        value: 'endereco',
                      },
                      {
                        label: 'Nome/CNPJ do hotel',
                        value: 'razao',
                      },
                    ],
                  },
                  {
                    name: 'label',
                    type: 'ShortText',
                    label: 'Nome do contato',
                    default: '',
                  },
                  {
                    name: 'enableLinkURL',
                    type: 'Checkbox',
                    label: 'Adicionar Link',
                    default: false,
                    isEnabled() {
                      return (
                        this.contactType === 'endereco' ||
                        this.contactType === 'razao'
                      );
                    },
                  },
                  {
                    name: 'linkURL',
                    type: 'Url',
                    isEnabled() {
                      return this.enableLinkURL;
                    },
                  },
                  {
                    name: 'ddi',
                    type: 'ShortText',
                    label: 'DDI',
                    maxlength: 4,
                    default: '',
                    isEnabled() {
                      return (
                        this.contactType === 'whatsapp' ||
                        this.contactType === 'telefone'
                      );
                    },
                  },
                  {
                    name: 'ddd',
                    type: 'ShortText',
                    label: 'DDD',
                    default: '',
                    isEnabled() {
                      return (
                        this.contactType === 'whatsapp' ||
                        this.contactType === 'telefone'
                      );
                    },
                  },
                  {
                    name: 'number',
                    type: 'ShortText',
                    label: 'Telefone',
                    default: '',
                    isEnabled() {
                      return (
                        this.contactType === 'whatsapp' ||
                        this.contactType === 'telefone'
                      );
                    },
                  },
                  {
                    name: 'email',
                    type: 'ShortText',
                    label: 'E-mail',
                    default: '',
                    isEnabled() {
                      return this.contactType === 'email';
                    },
                  },
                ],
              },
            ],
          },
          {
            name: 'socialLinks',
            label: 'Redes Sociais',
            fields: [
              {
                name: 'secondTitleColumn',
                type: 'ShortText',
                label: 'Título',
              },
              {
                name: 'socialLinks',
                type: 'List',
                itemLabel: 'Link social {index}',
                addItemLabel: 'Adicionar link social',
                fields: [
                  {
                    name: 'socialType',
                    type: 'VueSelect',
                    label: 'Tipo de link social',
                    default: '',
                    options: [
                      {
                        label: 'Instagram',
                        value: 'instagramLink',
                      },
                      {
                        label: 'YouTube',
                        value: 'youTubeLink',
                      },
                      {
                        label: 'Facebook',
                        value: 'facebookLink',
                      },
                      {
                        label: 'LinkedIn',
                        value: 'linkedinLink',
                      },
                      {
                        label: 'TripAdvisor',
                        value: 'tripAdvisorLink',
                      },
                      {
                        label: 'Twitter',
                        value: 'twitterLink',
                      },
                      {
                        label: 'Spotify',
                        value: 'spotifyLink',
                      },
                      {
                        label: 'TikTok',
                        value: 'tiktokLink',
                      },
                      {
                        label: 'WhatsApp',
                        value: 'whatsApp',
                      },
                    ],
                  },
                  {
                    name: 'title',
                    type: 'ShortText',
                    label: 'Texto alternativo (para SEO)',
                    default: '',
                  },
                  {
                    name: 'linkURL',
                    type: 'Url',
                    availableTypes: ['externalLink'],
                  },
                ],
              },
            ],
          },
          {
            name: 'links',
            label: 'Links úteis',
            fields: [
              {
                name: 'thirdTitleColumn',
                type: 'ShortText',
                label: 'Título',
              },
              {
                name: 'menuLinks',
                type: 'MenuSelect',
                label: 'Tipo de menu',
                helpText:
                  'Abaixo você poderá escolher entre usar um menu customizado, exclusivo para este módulo, ou usar um menu global reutilizável através de módulos e páginas',
                customMenuLabel: 'Itens do menu',
                customMenuHelpText:
                  'Reorganize os itens do menu os arrastando. Crie um submenu movendo um item para dentro de outro.',
                customMenuDefault: [
                  {
                    linkText: 'Pmweb',
                    linkUrl: {
                      type: 'externalLink',
                      value: '',
                      openInNewTab: true,
                    },
                    menuLinks: [],
                  },
                ],
              },
            ],
          },
          {
            name: 'paymentOptions',
            label: 'Formas de pagamento',
            isEnabled({ hasLetsbookIntegration }) {
              return hasLetsbookIntegration;
            },
            fields: [
              {
                name: 'paymentTitleColumn',
                type: 'ShortText',
                label: 'Título',
              },
              {
                name: 'flagsOption',
                type: 'VueSelect',
                label: 'Qual forma deseja mostrar?',
                default: 'without',
                options: [
                  {
                    label: 'Nenhuma',
                    value: 'without',
                  },
                  {
                    label: 'Formas de pagamento da Rede',
                    value: 'chain',
                  },
                  {
                    label: 'Formas de pagamento do Hotel',
                    value: 'hotel',
                  },
                ],
              },
              {
                name: 'hotelId',
                type: 'VueSelect',
                label: 'Selecione um hotel',
                default: '',
                isEnabled({ flagsOption }) {
                  return flagsOption === 'hotel';
                },
                options() {
                  const hotelsToOptions = (hotels) =>
                    hotels.map((hotel) => ({
                      label: hotel.Nome,
                      value: hotel.Codigo,
                    }));

                  // Are hotels already loaded?
                  if (this.hotels.length > 0) {
                    return hotelsToOptions(this.hotels);
                  }

                  // THIS IS PURE MAGIC
                  return new Promise((resolve) => {
                    const unwatch = this.$watch('hotels', (hotels) => {
                      resolve(hotelsToOptions(hotels));
                      unwatch();
                    });
                  });
                },
              },
            ],
          },
          {
            name: 'hotelName',
            label: 'Nome do hotel/rede',
            fields: [
              {
                name: 'hotelName',
                type: 'ShortText',
                label: 'Nome',
                helpText:
                  'Essa informação vai aparecer na parte inferior esquerda do Rodapé.',
              },
            ],
          },
          {
            name: 'termsOfUse',
            label: 'Termos de Uso',
            helpText:
              'Termos de uso são diretrizes que os usuários devem concordar para acessar seu site.',
            fields: [
              {
                name: 'termosTitle',
                type: 'ShortText',
                label: 'Título',
                maxlength: 40,
              },
              {
                name: 'termosType',
                type: 'VueSelect',
                label: 'Tipo',
                default: '',
                options: [
                  {
                    label: 'Sem Termos de uso',
                    value: '',
                  },
                  {
                    label: 'Modal',
                    value: 'modal',
                  },
                  {
                    label: 'Arquivo',
                    value: 'file',
                  },
                  {
                    label: 'Link/URL',
                    value: 'link',
                  },
                ],
              },
              {
                name: 'termosText',
                type: 'Html',
                label: 'Texto Modal',
                isEnabled({ termosType }) {
                  return termosType === 'modal';
                },
                wrapWithParagraph: false,
                validation: {
                  presence: {
                    allowEmpty: false,
                    message: 'Adicione o texto do modal de termos de uso',
                  },
                },
              },
              {
                name: 'termosMaterial',
                type: 'File',
                label: 'Arquivo',
                maxFileSize: 25,
                isEnabled({ termosType }) {
                  return termosType === 'file';
                },
                helpText: 'São aceitos arquivos do tipo: PDF, Docx, JPG e PNG.',
              },
              {
                name: 'termosLink',
                type: 'Url',
                availableTypes: [
                  'externalLink',
                  'page',
                  'anchor',
                  'dynamicPage',
                ],
                isEnabled({ termosType }) {
                  return termosType === 'link';
                },
                wrapWithParagraph: false,
              },
            ],
          },
          {
            name: 'privacyPolicy',
            label: 'Política de Privacidade',
            helpText:
              'Políticas de privacidade são direitos e deveres relacionados aos dados dos usuários e como você os utiliza.',
            fields: [
              {
                name: 'politicasTitle',
                type: 'ShortText',
                label: 'Título',
                maxlength: 40,
              },
              {
                name: 'politicasType',
                type: 'VueSelect',
                label: 'Tipo',
                default: '',
                options: [
                  {
                    label: 'Sem Política de Privacidade',
                    value: '',
                  },
                  {
                    label: 'Modal',
                    value: 'modal',
                  },
                  {
                    label: 'Arquivo',
                    value: 'file',
                  },
                  {
                    label: 'Link/URL',
                    value: 'link',
                  },
                ],
              },
              {
                name: 'politicasText',
                type: 'Html',
                label: 'Texto Modal',
                isEnabled({ politicasType }) {
                  return politicasType === 'modal';
                },
                wrapWithParagraph: false,
                validation: {
                  presence: {
                    allowEmpty: false,
                    message:
                      'Adicione o texto do modal de políticas de privacidade',
                  },
                },
              },
              {
                name: 'politicasMaterial',
                type: 'File',
                label: 'Arquivo',
                maxFileSize: 25,
                isEnabled({ politicasType }) {
                  return politicasType === 'file';
                },
                helpText: 'São aceitos arquivos do tipo: PDF, Docx, JPG e PNG.',
              },
              {
                name: 'politicasLink',
                type: 'Url',
                availableTypes: [
                  'externalLink',
                  'page',
                  'anchor',
                  'dynamicPage',
                ],
                isEnabled({ politicasType }) {
                  return politicasType === 'link';
                },
                wrapWithParagraph: false,
              },
            ],
          },
        ],
        toRemove: ['text'],
      },
      {
        name: 'appearance',
        groups: [
          {
            name: 'colors',
            fields: [
              {
                name: 'backgroundColorFooter', // migrate this field
                type: 'ColorPicker',
                label: 'Cor de fundo',
              },
            ],
            toRemove: [
              'backgroundColor',
              'titleColor',
              'buttonColor',
              'buttonTextColor',
            ],
          },
        ],
        toRemove: ['fonts'],
      },
    ],
  },
};
</script>

<style scoped lang="scss">
.module-footer {
  font-size: $size-small;
  color: var(--text-color);

  .footer {
    .not-active {
      pointer-events: none;
      cursor: default;
      text-decoration: none;
    }

    .column {
      display: inline-block;
      vertical-align: top;
      width: calc(100% / 3);
      margin: 0 -5px;
      padding: 0 72px;

      @include media-breakpoint-down(lg) {
        width: 100%;
        padding: 0 32px;

        + .column {
          margin-top: 32px;
        }
      }
    }

    .footer-title {
      font-size: 18px;
      font-style: normal;
      font-weight: $lb-bold;
      line-height: 21px;
      letter-spacing: 0em;
      text-align: left;
      border-bottom: 1px solid $lb-white;
      display: inline-block;
      padding: 8px 0;
      margin-bottom: 32px;
    }

    &__main {
      padding: 0;
      padding-top: var(--padding-top);
      padding-bottom: var(--padding-bottom);

      @include media-breakpoint-down(sm) {
        padding-top: var(--padding-top-mobile);
        padding-bottom: var(--padding-bottom-mobile);
      }
    }

    .align-left {
      text-align: left;
      padding-left: 30px;
    }

    .contact-links {
      text-align: left;

      &__list {
        &__icon {
          width: 16px;
          display: inline-block;
          margin-right: 15px;
          position: absolute;
          left: 0;
          top: 0;
        }

        &__item {
          + .contact-links__list__item {
            margin-top: 32px;
          }

          &__link {
            position: relative;
            display: block;
            color: inherit;
            padding-left: 32px;

            .contact-label {
              font-weight: $lb-bold;
            }
          }
        }
      }
    }

    .social-e-flag {
      text-align: left;
      position: relative;

      @include media-breakpoint-down(lg) {
        min-height: 0;
      }

      .before,
      .after {
        content: '';
        height: 70%;
        width: 1px;
        position: absolute;
        top: 0;
        margin-top: 10%;
        opacity: 0.1;

        @include media-breakpoint-down(lg) {
          display: none;
        }
      }

      .before {
        left: 0;
      }

      .after {
        right: 0;
      }
    }

    .flags {
      margin-bottom: 32px;

      &__list {
        &__item {
          display: inline-block;
          margin: 0 16px 8px 0;

          &__flag {
            width: 60px;
          }
        }
      }
    }

    .socials {
      &__list {
        &__item {
          display: inline-block;

          &__link {
            width: 30px;
            display: inline-block;
            vertical-align: top;
            margin: 0 16px 16px 0;
          }
        }
      }
    }

    .links {
      text-align: left;
      position: relative;

      .before {
        content: '';
        height: 70%;
        width: 1px;
        position: absolute;
        top: 0;
        margin-top: 10%;
        opacity: 0.1;

        @include media-breakpoint-down(lg) {
          display: none;
        }
      }

      .before {
        left: 0;
      }

      &__list {
        &__item {
          padding-bottom: 16px;

          &__link {
            color: inherit;
            text-decoration: underline;
          }

          li {
            padding: 8px 0 0 12px;
          }
        }
      }
    }

    &__bottom {
      padding: 24px 0;

      .container {
        padding: 0;
      }

      &__name {
        width: 30% !important;
        height: 50px;
        line-height: 50px;
        text-align: left;
        font-weight: $lb-bold;

        @include media-breakpoint-down(lg) {
          width: 100% !important;
          text-align: center;
        }
      }

      &__links {
        width: 40% !important;
        height: 50px;
        display: inline-flex !important;
        flex-wrap: wrap;
        align-items: center;
        justify-content: center;
        padding: 0 !important;

        @include media-breakpoint-down(lg) {
          width: 100% !important;
          height: auto;
          text-align: center;
          flex-direction: column;
          margin-bottom: 15px !important;
        }

        &__item {
          display: inline-block;
          margin: 0 20px;
          padding: 2px 0;

          &:hover {
            text-decoration: underline;
            cursor: pointer;
          }

          @include media-breakpoint-down(lg) {
            width: 100%;
            padding: 0;
            margin: 0 0 15px 0;
            height: 30px;
          }

          .editor-link {
            color: inherit;
          }
        }
      }

      &__letsbook {
        width: 30% !important;
        height: 50px;
        font-weight: $lb-bold;
        display: inline-flex !important;
        align-items: center;
        justify-content: flex-end;

        @include media-breakpoint-down(lg) {
          width: 100% !important;
          text-align: center;
          justify-content: center;
        }

        .logo {
          width: 127px;
          max-height: 50px;
          display: inline-block;
          margin-left: 15px;
        }
      }
    }
  }
}
</style>
